import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { ScriptManagementStores } from '../../script_management/stores';
import { STORE_SCRIPT_MANAGEMENT } from '../../script_management/stores/constants';
import ScriptManagementList from '../../script_management/components/ScriptManagementList';

const ScriptManagementPage: React.FC<ScriptManagementStores> = ({ scriptManagementUI: store }) => {
    if (!store) {
        return null;
    }
    return <ScriptManagementList store={store} />;
};

export default inject(STORE_SCRIPT_MANAGEMENT)(observer(ScriptManagementPage));
